import { getHeaders } from "../helpers/utils";
import api from "./ApiService";

const getSponsorData = async (data) => {
  const res = await api.post("Report/Sponsor", data, {
    headers: getHeaders(),
  });
  return res.data;
};

const ReportService = {
  getSponsorData,
};

export default ReportService;
